import { Reducer } from 'redux';

// Types
import { ProductState, ProductTypes } from './types';

const INITIAL_STATE: ProductState = {
  productsList: [],
  ticketResavationList: [],
  product: null,
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<ProductState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST PRODUCTS
    case ProductTypes.LIST_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        productsList: INITIAL_STATE.productsList,
      };
    case ProductTypes.LIST_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        productsList: action.payload.productsList,
        totalCount: action.payload.totalCount,
      };
    case ProductTypes.LIST_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        productsList: INITIAL_STATE.productsList,
      };
    case ProductTypes.LIST_TICKET_RESAVATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        ticketResavationList: action.payload.ticketResavationList,
        totalCount: action.payload.totalCount,
      };

    // CASES FILTER PRODUCTS
    case ProductTypes.FILTER_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        productsList: INITIAL_STATE.productsList,
      };
    case ProductTypes.FILTER_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        productsList: action.payload.productsList,
        totalCount: action.payload.totalCount,
      };
    case ProductTypes.FILTER_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        productsList: INITIAL_STATE.productsList,
      };

    // CASES CREATE PRODUCT
    case ProductTypes.CREATE_PRODUCT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        product: INITIAL_STATE.product,
      };
    case ProductTypes.CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        product: action.payload.product,
      };
    case ProductTypes.CREATE_PRODUCT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        product: INITIAL_STATE.product,
      };

    // CASES UPDATE PRODUCT
    case ProductTypes.UPDATE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: false };

    case ProductTypes.UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        product: action.payload.product,
      };
    case ProductTypes.UPDATE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: true };

    // CASES DELETE PRODUCT
    case ProductTypes.DELETE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: false };

    case ProductTypes.DELETE_PRODUCT_SUCCESS:
      return { ...state, loading: false, error: false };

    case ProductTypes.DELETE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return state;
  }
};

export default reducer;
